import React, { useState } from 'react';
import { ClientsTable } from '../components/clients/ClientsTable';
import { CreateClientModal } from '../components/clients/CreateClientModal';
import { ClientCreate } from '../api/models/ClientCreate';
import { clientService } from '../services/clientService';
import { useClientAccess } from '../hooks/useClientAccess';
import { useI18n } from '../contexts/I18nContext';
import '../styles/config-templates.css';

/** The client organisations: their fleet, their SIREN, their users. */
export const ClientsPage: React.FC = () => {
  // An ANEP Viewer reads this screen; only a manager may onboard a client.
  const { canManageClients } = useClientAccess();
  const { t } = useI18n();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [refreshClients, setRefreshClients] = useState(0);

  const handleClientCreated = (_client: ClientCreate) => {
    // Clear client cache so the new client appears in every dropdown.
    clientService.clearCache();
    setRefreshClients(prev => prev + 1);
  };

  return (
    <div className="page clients-page">
      <div className="page-header">
        <div className="page-title">
          <h1>{t('clients.clients')}</h1>
          <p>{t('clients.subtitle')}</p>
        </div>
        <div className="page-actions">
          {canManageClients && (
            <button type="button" className="create-client-btn" data-testid="btn-add-client" onClick={() => setShowCreateModal(true)}>
              <span className="add-type-icon" aria-hidden="true">+</span>
              {t('clients.addClient')}
            </button>
          )}
        </div>
      </div>

      <div className="page-content clients-content">
        <ClientsTable
          onClientSelect={() => {}}
          refreshTrigger={refreshClients}
        />
      </div>

      <CreateClientModal
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        onClientCreated={handleClientCreated}
      />
    </div>
  );
};
